import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";

import { BaseFlex, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const ListItem = styled(BaseFlex)<{ hideClearButton?: boolean }>`
    padding: 4px;
    transition: background-color 0.4s ease-out;

    &:hover {
        background-color: ${({ hideClearButton }) => (hideClearButton ? "transparent" : colorsPalettes.carbon[25])};
    }
`;

export const ListItemIcon = styled(BaseFlex)<{ isViewer: boolean }>`
    margin-right: 16px;
    width: 32px;
    height: 32px;
    background-color: ${({ isViewer }) => (isViewer ? `${colorsPalettes.carbon[0]}` : `${colorsPalettes.carbon[50]}`)};
    border: 1px dashed ${({ isViewer }) => (isViewer ? `${colorsPalettes.carbon[300]}` : "transparent")};
    border-radius: 20px;

    .SWReactIcons {
        path {
            fill: ${colorsPalettes.carbon[300]};
        }
    }
`;

const ListItemText = styled.div`
    max-width: 280px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const ListItemName = styled(ListItemText)`
    ${setFontVariant("body1", colorsPalettes.carbon["500"])};
`;

export const ListItemNameAbbr = styled.span`
    color: ${colorsPalettes.carbon[250]};
`;

export const ListItemEmail = styled(ListItemText)`
    ${setFontVariant("body2", colorsPalettes.carbon["300"])};
`;

export const CloseIconButton = styled(IconButton)`
    display: none;

    ${ListItem}:hover & {
        display: flex;
    }
`;

export const ListItemRoleStatus = styled(FlexRow)<{ alwaysDisplay?: boolean }>`
    ${setFontVariant("body1", colorsPalettes.carbon["300"])};

    ${ListItem}:hover & {
        display: ${({ alwaysDisplay }) => (alwaysDisplay ? "flex" : "none")};
    }
`;

export const ButtonWrapper = styled.div`
    display: inline-flex;
`;

export const TooltipWrapper = styled.div`
    position: relative;
`;
